export default __webpack_public_path__ + "static/media/logovietgrp.4a48539a.svg";